import { useEffect, useState } from 'react';

function readCssVarPx(varName) {
  if (typeof window === 'undefined') return null;
  const raw = window.getComputedStyle(document.documentElement).getPropertyValue(varName);
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return null;
  const n = Number.parseFloat(trimmed);
  return Number.isFinite(n) ? n : null;
}

export function useCssVarPx(varName, fallbackPx) {
  const [value, setValue] = useState(() => readCssVarPx(varName) ?? fallbackPx);

  useEffect(() => {
    const update = () => setValue(readCssVarPx(varName) ?? fallbackPx);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [varName, fallbackPx]);

  return value;
}
